import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Tooltip } from '@michelin/acid-components'
import InfoIcon from '@material-ui/icons/Info'
import moment from 'moment'

const styles = theme => ({
	icon: {
		fontSize: '24px',
		marginLeft: theme.spacing(1)
	}
})

class MaterialHeadline extends React.Component {
	constructor(props) {
		super(props)

		this.state = { hasError: false }
	}

	componentDidCatch(error, info) {
		this.setState({ hasError: true })
	}

	render() {
		const { classes, title, source, modifiedDate } = this.props
		const showIcon = (source !== '') || (modifiedDate !== '')

		return (
			<React.Fragment>
				{title}
				{showIcon &&
					<Tooltip title={
						<div>
							{(source !== '') ? `Source: ${source}` : ''} 
							{(source !== '') && < br />}
							{(modifiedDate !== '') ? `Updated on ${moment(modifiedDate).format('L LT')}` : ''}								
						</div>
					}>
						<InfoIcon className={classes.icon} color={source !== 'Ship To' ? 'primary' : 'secondary'} />
					</Tooltip>
				}
			</React.Fragment>
		)
	}
}

MaterialHeadline.propTypes = {
	classes: PropTypes.object,
	title: PropTypes.string,
	source: PropTypes.string,
	modifiedDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]),
}

MaterialHeadline.defaultProps = {
	source: '',
	modifiedDate: ''
}

export default withStyles(styles)(MaterialHeadline)


// WEBPACK FOOTER //
// ./src/components/MaterialHeadline.js